/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

import {OverlayModule} from '@angular/cdk/overlay';
import {NgModule} from '@angular/core';
import {MatOptionModule} from '../core';
import {MatFormFieldModule} from '../form-field';
import {CdkScrollableModule} from '@angular/cdk/scrolling';
import {MatSelect, MatSelectTrigger} from './select';
import {BidiModule} from '@angular/cdk/bidi';

@NgModule({
  imports: [OverlayModule, MatOptionModule, MatSelect, MatSelectTrigger],
  exports: [
    BidiModule,
    CdkScrollableModule,
    MatFormFieldModule,
    MatSelect,
    MatSelectTrigger,
    MatOptionModule,
  ],
})
export class MatSelectModule {}
